import { API } from '../config';

export async function getEvents(param: { token: string }) {
  try {
    // Let's check if the token is provided
    if (!param.token) throw new Error('Token is not provided.');

    const result = await fetch(`${API}/events/global`, {
      headers: {
        Authorization: `Bearer ${param.token}`,
      },
      mode: 'cors',
    });

    return await result.json()
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getSpeechAudio(params: { token: string, text: string }) {
  try {
    // Let's check if the token is provided
    if (!params.token) throw new Error('Token is not provided.');

    const result = await fetch(`${API}/tts/synthesize`, {
      method: 'POST',
      body: JSON.stringify({ text: params.text }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${params.token}`,
      },
      mode: 'cors',
    });

    return await result.json()
  } catch (error) {
    return Promise.reject(error);
  }
}
